import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { SupportService } from '../../../core/services/support.service';
import { ModalComponent } from '@mlc/shared/modal/modal.component';
import { SpinnerComponent } from '@mlc/shared/spinner/spinner.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-help-desk',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, ModalComponent],
  templateUrl: './help-desk.component.html',
})
export class HelpDeskComponent {
  helpDeskForm: FormGroup;
  isLoading = signal(false);
  confirmationMessage = signal<string | null>(null);
  errorMessage = signal<string | null>(null);
  showCancelModal = signal(false);

  @Output() close = new EventEmitter<void>();

  private authService = inject(AuthService);
  private loggedInUser = toSignal(this.authService.getLoggedInUser());

  constructor(private fb: FormBuilder, private supportService: SupportService) {
    this.helpDeskForm = this.fb.group({
      subject: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  onSubmit() {
    this.confirmationMessage.set(null);
    this.errorMessage.set(null);

    if (this.helpDeskForm.invalid) {
      this.helpDeskForm.markAllAsTouched();
      return;
    }

    const currentUser = this.loggedInUser();
    if (!currentUser) {
      this.errorMessage.set('You must be logged in to submit a ticket.');
      return;
    }

    this.isLoading.set(true);
    const { subject, description } = this.helpDeskForm.getRawValue();
    const ticketData = {
      subject,
      description,
    };

    this.supportService
      .submitTicket(ticketData)
      .then(() => {
        this.confirmationMessage.set('Your ticket has been submitted successfully!');
        this.helpDeskForm.reset();
        setTimeout(() => this.close.emit(), 2000);
      })
      .catch((err) => {
        console.error('Error submitting ticket:', err);
        this.errorMessage.set('An error occurred while submitting your ticket.');
      })
      .finally(() => {
        this.isLoading.set(false);
      });
  }

  onCancel() {
    this.close.emit();
    // TODO: Clean up the double modal invocation
    // if (this.helpDeskForm.dirty) {
    //   this.showCancelModal.set(true);
    // } else {
    //   this.close.emit();
    // }
    // this.showCancelModal.set(false);
  }

  closeCancelModal() {
    this.showCancelModal.set(false);
  }

  confirmCancel() {
    this.closeCancelModal();
    this.close.emit();
  }
}
